export default "__VITE_ASSET__88e2b50b__"